(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('nd-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('[data-nd-reveal]').forEach(function (el) {
    observer.observe(el);
  });

  document.querySelectorAll('[data-nd-reveal-children]').forEach(function (parent) {
    var children = parent.querySelectorAll('[data-nd-child]');
    if (children.length === 0) {
      children = parent.children;
    }
    var staggerMs = parseInt(parent.dataset.ndRevealChildren, 10) || 100;

    var parentObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          Array.prototype.forEach.call(children, function (child, i) {
            child.style.transitionDelay = (i * staggerMs) + 'ms';
            child.classList.add('nd-visible');
          });
          parentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    parentObserver.observe(parent);
  });
})();
